import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const GetAllTenantMaintenanceRequest = createAsyncThunk(
  "dummyData/tenantMaintenanceRequest",
  async ({ tenantId, flatId }) => {
    let response = await axios.get(
      `${BASE_URL}/get-maintenance-request/${tenantId}/${flatId}`
    );
    return response.data; // ALWAYS RETURN DATA ONLY
  }
);

const GetTenantMaintenanceAll = createSlice({
  name: "tenantMaintenanceRequest",
  initialState: {
    loading: false,
    GetTenantMaintenanceAll: [],
    error: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTenantMaintenanceRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllTenantMaintenanceRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.GetTenantMaintenanceAll = action.payload;
      })
      .addCase(GetAllTenantMaintenanceRequest.rejected, (state, action) => {
        state.loading = false; // FIX REQUIRED
        state.error = action.error.message;
      });
  },
});

export default GetTenantMaintenanceAll.reducer;
